<template>
  <div>
    <div>
      <div class="d-flex flex-row-column justify-content-between">
        <div class="d-inline-block mb-2 mt-2">
          <span @click="emit('reset')" class="page-title">
            <router-link to="/lmt/deposit/create">Make a Deposit</router-link>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span class="page-title">
            <a
              href="#"
              v-if="data.deposit_type_id!=1"
              @click="emit('add-agents')"
              to="/lmt/deposit/create"
            >{{ $t('agent_specific.choose_agent') }}</a>
            <span v-else to="/lmt/deposit/create">{{ $t('agent_specific.choose_agent') }}</span>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span @click="emit('add-transactions')" class="page-title">
            <router-link to="/lmt/deposit/create">Choose Transactions</router-link>
          </span>
          <img src="../../../assets/icons/iconNextPage.svg" class="mx-1" />
          <span class="page-title">Selected for Deposit</span>
        </div>
        <span class="d-flex flex-row-column">
          <span class="input-width-160 r-width-100 d-inline-block mr-3">
            <md-button
              :disabled="getBalance==0 || createPopup==1"
              v-on:click="createPopup=1"
              class="md-primary md-raised c-primary mb-2 ml-0"
            >
              <template>Create Deposit</template>
            </md-button>
          </span>
        </span>
      </div>
      <hr class="mt-0" />
      <div class="d-flex flex-row-column justify-content-between pr-5">
        <span>
          <span class="d-inline-block gray-header mr-2">Total for Deposit:</span> $
          <span class="f-s-18">{{(getBalance).toFixed(2)}}</span>
        </span>
        <span>
          <a
            href="#"
            class="f-s-18"
            v-if="data.deposit_type_id!=1"
            @click="addMore"
          >Add More Transactions</a>
        </span>
      </div>
      <hr class="mb-0" />
      <md-table v-if="items" v-model="getItems">
        <md-table-row slot="md-table-row" slot-scope="{ item }">
          <md-table-cell md-label="TRX Date" md-sort-by="date_issued">{{ item.date_issued }}</md-table-cell>
          <md-table-cell :md-label="$t('slip_specific.sender')" md-sort-by="sender">{{ item.sender }}</md-table-cell>
          <md-table-cell md-label="Deposit Amount" md-sort-by="amount">{{ item.amount }}</md-table-cell>
          <md-table-cell md-label="Actions">
            <a href="#" v-on:click="remove(item.id)">Remove</a>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
    <confirm-popup v-if="createPopup" v-on:confirm="create" v-on:cancel="createPopup=0" />
  </div>
</template>
<script>
// import pagination methods paginationChange and changePerPage
import Pagination from "../../../mixins/pagination.js";

// mixin for loading data and state
import DataMixin from "../../../mixins/data.js";

import Confirm from "./Confirm";

export default {
  mixins: [Pagination, DataMixin],

  props: ["items", "data"],

  components: { "confirm-popup": Confirm },

  data() {
    return {
      status: "",
      agents: [],
      agent_id: "",
      search_term: "",
      // url for loading data
      api_url: "",
      createPopup: 0,
      flow: [
        { text: "Make a Deposit", link: "/lmt/deposit/create" },
        { text: this.$t('agent_specific.choose_agent'), link: "/lmt/deposit/create" },
        { text: "Choose Transactions", link: "/lmt/deposit/create" },
        { text: "Selected for Deposit" }
      ],
      deleted: []
    };
  },
  created() {
    // this.loadData();
  },
  methods: {
    remove(id) {
      this.deleted.push(id);
      Event.$emit("remove", [id]);
    },
    addMore() {
      Event.$emit("add-agents", [this.getItems]);
    },
    create() {
      let itm = this.getItems;
      let items_arr = [];
      itm.forEach(element => {
        items_arr.push(element.id);
      });

      axios
        .post("/lmt/make-deposit", { transaction_ids: items_arr, ...this.data })
        .then(({ data }) => {
          Event.$emit("message", [data.message]);
          this.$router.push("/lmt/deposit/history");
        });
    },
    emit(e) {
      Event.$emit(e);
    }
  },
  computed: {
    getFlow() {
      return this.flow;
    },
    getItems() {
      return this.items.filter(item => !this.deleted.includes(item.id));
    },
    getBalance() {
      let tmp = this.getItems;
      let total = 0;
      tmp.forEach(element => {
        total += parseFloat(element.amount);
      });
      return total;
    }
  }
};
</script>